import React from 'react';
import { useTranslation } from 'react-i18next';

var LANGS = [
  { code: 'fr', label: '🇫🇷' },
  { code: 'en', label: '🇬🇧' },
  { code: 'de', label: '🇩🇪' },
  { code: 'it', label: '🇨🇭' },
  { code: 'es', label: '🇪🇸' },
];

function LangSwitcher() {
  var _t = useTranslation(); var i18n = _t.i18n;
  var current = i18n.language ? i18n.language.substring(0, 2) : 'fr';

  return React.createElement('div', {
    style: { display: 'flex', gap: 4, justifyContent: 'center', flexWrap: 'wrap' }
  },
    LANGS.map(function(l) {
      var isActive = current === l.code;
      return React.createElement('button', {
        key: l.code,
        onClick: function() { i18n.changeLanguage(l.code); },
        style: {
          background: isActive ? 'rgba(232,196,124,0.3)' : 'transparent',
          border: isActive ? '1px solid rgba(232,196,124,0.6)' : '1px solid transparent',
          borderRadius: 8,
          padding: '4px 8px',
          cursor: 'pointer',
          fontSize: 18,
          lineHeight: 1,
          transition: 'all .2s'
        }
      }, l.label);
    })
  );
}

export default LangSwitcher;
